<div class="row" *ngIf="person">
  <div class="ir-area ir-mask th-mask">
    <form class="ir-modal th-modal" (ngSubmit)="save(editForm.value)" [formGroup]="editForm">
      <div class="ir-modal--title">
        <div class="ir-line--right">
          <!-- <div class="ir-btn th-btn-modal" (click)="openMenu()">
                        <i class="material-icons">more_vert</i>
                    </div> -->
        </div>
        <div class="ir-line">
          <div class="ir-line-content">
            <span>{{ 'settings.edit-user.edit-user-profile' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
        <div class="ir-content--modal th-content">
          <table class="ir-modal-table">
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'common.name' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <input type="text" name="name" class="ir-form-set" formControlName="name" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'common.description' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <input type="text" name="desc" class="ir-form-set" formControlName="desc" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'people.phone' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <input type="tel" name="phone" class="ir-form-set" formControlName="phone" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'people.email' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <input type="email" name="email" class="ir-form-set" formControlName="email" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'people.language' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <select name="language" class="ir-form-set" formControlName="language">
                    <option *ngFor="let language of languages | orderBy: 'name'" [value]="language.value">
                      {{ language.label }}
                    </option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'people.applications' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <h2>
                  <span *ngFor="let applicationType of applicationTypes; let last = last">
                    {{ applicationType.Label | translate }}
                    <ng-container *ngIf="!last">,</ng-container>
                  </span>
                </h2>
              </td>
            </tr>
            <tr style="display: none">
              <td class="margin-big">
                <h2>
                  <span>{{ 'people.office.name' | translate }}</span>
                </h2>
              </td>
              <td class="th-plugin-line--value margin-big">
                <div class="ir-line ir-select th-select">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-disabled">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      person.office ? (person.office | localEntity) : ('people.office.not-selected' | translate)
                    }}</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'people.profiles' | translate }}</span>
                </h2>
              </td>
              <td class="th-plugin-line--value margin-big">
                <div class="ir-line ir-select th-select">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-disabled">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span [innerHtml]="getSelectedValues()"></span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'people.localEntities' | translate }}</span>
                </h2>
              </td>
              <td class="th-plugin-line--value margin-big">
                <div class="ir-line ir-select th-select">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-disabled">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span [innerHtml]="getSelectedLocalEntitiesValues()"></span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'plugins.equipment-info.product-line' | translate }}</span>
                </h2>
              </td>
              <td class="th-plugin-line--value margin-big">
                <div class="ir-line ir-select th-select">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-disabled">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span [innerHtml]="getSelectedProductLineValues()"></span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'people.password' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <h2>
                  <span (click)="goToEditPassword()" class="clickable">{{ 'people.edit-password' | translate }}</span>
                </h2>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="ir-modal--footer ir-position--b th-modal--footer">
        <div class="ir-row">
          <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
            <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
              <span>{{ 'common.cancel' | translate }}</span>
            </div>
          </div>
          <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
            <button
              class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
              type="submit"
              [disabled]="editForm.invalid"
              *ngIf="!processing"
            >
              <span>{{ 'common.save-changes' | translate }}</span>
            </button>
            <button
              class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
              type="submit"
              *ngIf="processing"
            >
              <span>{{ 'common.processing' | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
